
<script lang="ts">

    import { preventDefault } from "./../Util/utils";
    import { bootstrapConfirmation, bootstrapTooltip } from './../Bootstrap';
    import { getTime } from "date-fns";
    import type { MyFitnessStores } from "./stores";
    import { Activity } from "@/Common/ActivityFunctions";
    import { CreateCustomEventDispatchHandler } from "@/EventDispatchers";
    import { onMount } from "svelte";
    import { draggable, DragType, dragInformation } from '../Common/DragAndDrop'

    export let myFitness: MyFitnessStores;
    export let exercise; //exercise
    export let date;
    export let exerciseCardDiv = null;
    export let isCardLoading = false;
    export const setCardLoading = null; 
    export let otherProfile = false;
    export let onDrag: (x: number, y: number) => void = null;
    export let isMobile: boolean;

    let root: HTMLElement;
    //@ts-ignore
    const Xert = window.Xert;
    const { selectedTrainingPlan, trainingPlan } = myFitness;
    let nextWeek = (new Date()).setDate((new Date()).getDate() + 7);

    //Dummy variables allow UI to react instantly while asynchronous requests take place in the background 
    $: isPinned = Activity.isPinned(exercise);
    $: isPlaceholder =  Activity.isPlaceholder(exercise)
    $: isPlanned = Activity.isPlanned(exercise)
    $: isManual = Activity.isManual(exercise)
    $: isStarred = Activity.isStarred(exercise)
    $: isFlagged = Activity.isFlagged(exercise);
    $: video_id = Activity.getVideoId(exercise)
    $: youtube_url = Activity.getYoutubeUrl(exercise)
    $: spotify_url = Activity.getSpotifyUrl(exercise)
    $: noActivity = Activity.noActivity(exercise)
    $: isForecastEvent = Activity.isForecastEvent(exercise)
    $: isIncomplete = Activity.isIncomplete(exercise)
    $: containerID= `${exercise?.path}_EventsBar`
    $: isGroupSession = exercise?.is_group_session ?? false
    $: isSessionOwner = exercise?.is_session_owner ?? false
    $: isGoalEvent = Activity.isGoalEvent(exercise);
    $: isRecorded = Activity.isRecorded(exercise);
    $: canDelete = Activity.canDelete(exercise);
    $: isAnchor = Activity.isAnchor(exercise);
    $: canFavorite = Activity.canFavorite(exercise);
    $: canEdit = Activity.canEdit(exercise)


    let eventCallBack = ()=>{
        selectedTrainingPlan.set(exercise)
    }

    function setIsLoading(v:boolean){
        isCardLoading = v
    }
    
    let eventDispatchHandler;
    let dispatchTrainingEvent;
    onMount(()=>{
        //Returns custom Event Dispatchers that can be used directly as event handlers
        //e.g. on:click={eventDispatcherHandler('myEvent', {...myEventDetails}, bubbles)}

        //Dispatches Custom Events that can be used within component methods
        //e.g. function myMethod() {/*modify component before call*/...; dispatchTrainingEvent('myEvent', {...myEventDetails}, bubbles); /*modify component after call*/  } 
        [eventDispatchHandler, dispatchTrainingEvent] = CreateCustomEventDispatchHandler(root, eventCallBack);
    })
    
 
    /////////////////////////////////////////////
    //Custom Events used by ForecastEventsBar ///
    /////////////////////////////////////////////

    function onTogglePinClick(){
        isPinned = !isPinned;
        dispatchTrainingEvent("onTogglePinClick", {exercise})
    }
    function onDeleteClick(){
        
        // setIsLoading(true);
        dispatchTrainingEvent("deleteActivity", {exercise})
        // setIsLoading(false);
        
    }
    function onStarClick(event: any) {
        isStarred = !isStarred;
        dispatchTrainingEvent("starActivity", {exercise})
    }

    function onLeaveSessionClick(event: any) {
        dispatchTrainingEvent("leaveSession", {exercise})
    }

    function onFlagClick(event: any) {
        isFlagged = !isFlagged;
        dispatchTrainingEvent("flagActivity", {exercise})
    }
    /////////////////////////
    //End of Custom Events///
    /////////////////////////

</script>
<div id={containerID} class='card-action-row'  bind:this={root}>
    {#if false && !isPlaceholder && canFavorite}
        <!-- Favorite icon removed for now because on an iPad or other narrow screen, there's too many buttons -->

        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <a use:bootstrapTooltip={{
            container: '#'+containerID,
            title: "Favourite"
        }} class="card-action-item" on:click={onStarClick}><i class="{!isStarred? "fa-regular" : "fa-solid"} fa-star fa-lg"></i></a>
    {/if}
    {#if !otherProfile && (exercise?.is_group_session ?? false) && !(exercise?.ended ?? true) && isPlanned}
        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <a use:bootstrapTooltip={{
            container: '#'+containerID,
            title: "Leave session"
        }} class="card-action-item" on:click={onLeaveSessionClick}><i class="fa-regular fa-right-from-bracket fa-xl"></i></a>
    {/if}
    {#if video_id}
        <a use:bootstrapTooltip={{
            container: '#'+containerID,
            title: "Youtube"
        }} class="card-action-item" target="_blank" rel="noopener noreferrer" href={youtube_url}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 575 512">
            <path stroke="currentColor" stroke-width="32" fill="none" d="M 547.65351,125.73817 C 541.40856,102.22391 523.00876,83.704803 499.64659,77.42008 457.30099,66 287.50001,66 287.50001,66 c 0,0 -169.79999,0 -212.146569,11.42008 C 51.991276,83.705793 33.591472,102.22391 27.346515,125.73817 16,168.35916 16,257.28387 16,257.28387 c 0,0 0,88.92469 11.346515,131.54564 6.244957,23.51427 24.644761,41.26186 48.006926,47.54656 42.346579,11.42008 212.146569,11.42008 212.146569,11.42008 0,0 169.8,0 212.14658,-11.42008 23.36217,-6.2847 41.76197,-24.03229 48.00692,-47.54656 11.34652,-42.62095 11.34652,-131.54564 11.34652,-131.54564 0,0 0,-88.92471 -11.34652,-131.5457 z M 231.96553,333.0208 V 181.54689 c 0,-2.23036 2.40734,-3.63045 4.34593,-2.52758 l 133.22805,75.79412 c 1.91724,1.09073 1.91721,3.85406 -5e-5,4.94475 l -133.22795,75.79029 a 2.9080519,2.9080519 30.182727 0 1 -4.34598,-2.52767 z"/>
            </svg>
        </a>
    {/if}
    {#if !otherProfile && isRecorded}
        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <a use:bootstrapTooltip={{
            container: '#'+containerID,
            title: "Flag this activity's fitness signature"
        }} class="card-action-item" on:click={onFlagClick}><i class="{!isFlagged ? "fa-regular" : "fa-solid"} fa-flag fa-xl"></i></a>
    {/if}
    {#if spotify_url}
        <a use:bootstrapTooltip={{
            container: '#'+containerID,
            title: "Spotify"
        }} class="card-action-item" target="_blank" rel="noopener noreferrer" title={spotify_url} href={spotify_url}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 500 500">
                <path xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="22" fill="none" d="m 345.35983,364.37502 c -3.97727,0 -6.4394,-1.23106 -10.13258,-3.40909 -59.09091,-35.60606 -127.84091,-37.12122 -195.73863,-23.20076 -3.69319,0.94697 -8.52273,2.46212 -11.26894,2.46212 -9.18561,0 -14.96212,-7.29167 -14.96212,-14.96212 0,-9.75379 5.77651,-14.39394 12.87878,-15.90909 77.55682,-17.14015 156.81819,-15.625 224.43182,24.8106 5.77652,3.69319 9.18561,7.00758 9.18561,15.625 0,8.61743 -6.72349,14.58334 -14.39394,14.58334 z m 25.47348,-62.12121 c -4.92424,0 -8.23863,-2.17803 -11.64772,-3.97728 -59.18561,-35.03788 -147.44319,-49.14772 -225.94697,-27.84091 -4.54546,1.23106 -7.00758,2.46212 -11.26894,2.46212 -10.13258,0 -18.37121,-8.23863 -18.37121,-18.37121 0,-10.13257 4.92424,-16.85606 14.67803,-19.60227 26.32575,-7.38636 53.21969,-12.87879 92.61363,-12.87879 61.45833,0 120.83333,15.24621 167.61364,43.08712 7.67045,4.54546 10.70076,10.41667 10.70076,18.65531 -0.0947,10.22727 -8.04925,18.46591 -18.37122,18.46591 z m 29.35606,-72.1591 c -4.92424,0 -7.95454,-1.23106 -12.21591,-3.69318 -67.42424,-40.24621 -187.97348,-49.9053 -266.00378,-28.125 -3.40909,0.94697 -7.67046,2.46212 -12.21591,2.46212 -12.499997,0 -22.064391,-9.75378 -22.064391,-22.34848 0,-12.87879 7.954545,-20.17046 16.477271,-22.63258 33.33333,-9.75378 70.64394,-14.39394 111.26894,-14.39394 69.12878,0 141.57197,14.39394 194.50757,45.26516 7.38637,4.26136 12.21591,10.13257 12.21591,21.40151 0,12.87879 -10.41667,22.06439 -21.9697,22.06439 z"/>
                <path xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="22" fill="none" d="M 250.0001,16 C 120.82826,16 16,120.82827 16,250.00009 c 0,129.17184 104.82826,234.00009 234.0001,234.00009 129.17185,0 234.0001,-104.82825 234.0001,-234.00009 C 484.0002,120.82827 379.17195,16 250.0001,16 Z"/>
            </svg>
        </a>
    {/if}

    {#if !isPlaceholder && (!isGroupSession || (isGroupSession && isSessionOwner) || isRecorded) && canDelete}
    <button use:bootstrapConfirmation={{
        onclick: onDeleteClick,
        placement: 'top',
        container: '#'+containerID,
        title: `${isForecastEvent ? 'Clear' : 'Delete'} this activity?`
    }}
    use:bootstrapTooltip={{
        container: '#'+containerID,
        title: isForecastEvent ? 'Clear' : 'Delete'
    }}
    class="card-action-item hasConfirmation">
        {#if !isForecastEvent}
            <i class="fa-regular fa-trash-can fa-lg"></i>
        {:else}
            <i class="fa-regular fa-xmark-large fa-lg"></i>
        {/if}
    </button>
    {/if}
    {#if !otherProfile && isGoalEvent}
        <i class="card-action-item cursor-default"></i>
    {:else if !otherProfile && (isForecastEvent || isPlanned || isManual || canEdit ) && !isAnchor}
        <button use:bootstrapTooltip={{
            container: '#'+containerID,
            title: isForecastEvent ? "Choose Training" : "Modify",
        }} on:click={eventDispatchHandler("editEvent", {date, exercise, setIsLoading})} class="card-action-item">
            <i class="fa-light fa-calendar-pen fa-lg"></i>
        </button>
    {/if}
    {#if !otherProfile && isPlaceholder && !noActivity && !isGoalEvent}
        <button title="Magic Buckets" on:click={eventDispatchHandler("editEvent", {date, exercise, setIsLoading, openTo: "magic"})} on:auxclick={preventDefault} class="card-action-item">
            <i class="fa-light fa-sparkles fa-lg"/>
        </button>
    {/if}
    {#if isForecastEvent && !isPlaceholder && !otherProfile} 
        {#if isPinned}
        <button on:click={onTogglePinClick} 
        use:bootstrapTooltip={{
            container: '#'+containerID,
            title:"Unpin from Calendar",
        }} 
        class="card-action-item"> 
        <i class = "fa-solid fa-thumbtack fa-lg"></i>
    </button>
        {:else}
        <button on:click={onTogglePinClick} 
        use:bootstrapTooltip={{
            container: '#'+containerID,
            title:"Pin to Calendar",
        }} 
        class="card-action-item"> 
        <i class = "fa-light fa-thumbtack fa-lg"></i>
    </button>
        {/if}
        
    {/if}
    <div class='card-action-divider'/>
    {#if !isPlaceholder && !isForecastEvent && !isMobile}
        <div use:draggable={{
                'data': {exercise, operation: DragType.COPY}, 'image': exerciseCardDiv,
                on_dragstart(operation) {
                    exerciseCardDiv?.classList.add("dragged")
                    dragInformation.set({
                        type: operation,
                    })
                },
                on_dragend() {
                    exerciseCardDiv?.classList.remove("dragged")
                },
                onDrag,
            }}
            use:bootstrapTooltip={{
                container: '#'+containerID,
                title: "Copy"
            }}
            class="card-action-item"
        >
            <i class="fa-light fa-copy fa-lg"></i>
        </div>
    {/if}
    {#if !isPlaceholder && !isForecastEvent && (isPlanned || isManual) && !isMobile}
        <div use:draggable={{
                'data': {exercise, operation: DragType.MOVE}, 'image': exerciseCardDiv,
                on_dragstart(operation) {
                    exerciseCardDiv?.classList.add("dragged")
                    dragInformation.set({
                        type: operation,
                    })
                },
                on_dragend() {
                    exerciseCardDiv?.classList.remove("dragged")
                },
                onDrag,
            }}
            use:bootstrapTooltip={{
                container: '#'+containerID,
                title: "Move"
            }} class="card-action-item"
        >
            <i class="fa-light fa-calendar-day fa-lg"></i>
        </div>
    {/if}
    {#if isForecastEvent && !isGoalEvent && !isMobile}
        <div use:draggable={{
                'data': {exercise, operation: DragType.SWAP}, 'image': exerciseCardDiv,
                on_dragstart(operation) {
                    exerciseCardDiv?.classList.add("dragged")
                    dragInformation.set({
                        type: operation,
                    })
                },
                on_dragend() {
                    exerciseCardDiv?.classList.remove("dragged")
                },
                onDrag,
            }}
            use:bootstrapTooltip={{
                container: '#'+containerID,
                title: "Swap"
            }} class="card-action-item"
        >
            <i class="fa-light fa-swap fa-lg"></i>
        </div>
    {/if}
</div>

<style lang="scss">
     @import './../style/xert.scss';

     button {
        all: unset;
    }

    .card-action-row { // This is sized perfectly to match the bottom buttons in CalendarCard.svelte
        width:100%;
        border-top:2px solid #aaa;
        // box-shadow: 0px 0px 2px 2px #aaa;
        position: relative;
        display: flex;
        justify-content: left;
        flex-direction: row;
    }

    .card-action-item {
        width: 24px;
        height: 24px;
        display: grid;
        place-items: center;
        color: #34495e;
        text-decoration: none;
        margin: 5px 0%;
    }

    .card-action-divider {
        flex-grow: 1;
    }

    .card-action-item:hover {
        opacity: 0.8;
        cursor: pointer;
    }

    .card-title-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
        h5 {
            line-height: normal;
        }
    }
    .card-tag {
        padding: 4px 8px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        border-radius: 90px;
        border-color: black;
        border-width: 2px;
    }
    .card-info-row {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
    }

</style>
